<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Usuários</h6>
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <p class="text-sm mb-0">
          <span class="font-weight-bold">{{ usuarios.length }}</span> usuários encontrados
        </p>
        <div class="d-flex flex-wrap gap-2">
          <button
            @click="showAddModal"
            class="btn btn-sm btn-custom-gradient"
          >
            Adicionar
          </button>
          <button
            @click="loadUsuarios"
            class="btn btn-sm"
            :class="loading ? 'btn-secondary' : 'btn-custom-gradient'"
            :disabled="loading"
          >
            {{ loading ? 'Carregando...' : 'Atualizar' }}
          </button>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="error" class="alert alert-danger mx-3">
        {{ error }}
      </div>
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-teal" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
      <div v-else class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Nome
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                E-mail
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="usuario in usuarios" :key="usuario.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ usuario.name }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      ID: {{ usuario.id }}
                    </p>
                  </div>
                </div>
              </td>
              <td class="align-middle">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ usuario.email }}
                </span>
              </td>
              <td class="align-middle">
                <div class="d-flex align-items-center justify-content-end gap-2 pe-3">
                  <a
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Ver detalhes"
                    @click="viewDetails(usuario)"
                  >
                    Detalhes
                  </a>
                  <a
                    href="javascript:;"
                    class="text-info"
                    data-toggle="tooltip"
                    data-original-title="Editar usuário"
                    @click="editUser(usuario)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="text-danger"
                    data-toggle="tooltip"
                    data-original-title="Excluir usuário"
                    @click="deleteUser(usuario)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="usuarios.length === 0 && !loading">
              <td colspan="3" class="text-center py-4">
                <p class="text-secondary">Nenhum usuário encontrado</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal de Adicionar Usuário -->
    <div v-if="showAddUserModal" class="modal-backdrop fade show" @click="closeAddModal" style="z-index: 9999;"></div>
    <div v-if="showAddUserModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalLabel">
              <i class="fas fa-plus me-2"></i>
              Adicionar Novo Usuário
            </h5>
            <button type="button" class="btn-close" @click="closeAddModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingAdd" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Cadastrando usuário...</p>
            </div>
            <div v-else>
              <div v-if="addError" class="alert alert-danger">
                {{ addError }}
              </div>
              <form @submit.prevent="addUser">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="userName" class="form-label">Nome *</label>
                    <input
                      type="text"
                      class="form-control"
                      id="userName"
                      v-model="newUser.name"
                      placeholder="Ex: Rafael"
                      required
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="userEmail" class="form-label">E-mail *</label>
                    <input
                      type="email"
                      class="form-control"
                      id="userEmail"
                      v-model="newUser.email"
                      placeholder="Ex: rafael@exemplo.com"
                      required
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="userPassword" class="form-label">Senha *</label>
                    <input
                      type="password"
                      class="form-control"
                      id="userPassword"
                      v-model="newUser.password"
                      placeholder="Senha"
                      required
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="userPasswordConfirmation" class="form-label">Confirmar Senha *</label>
                    <input
                      type="password"
                      class="form-control"
                      id="userPasswordConfirmation"
                      v-model="newUser.password_confirmation"
                      placeholder="Confirme a senha"
                      required
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeAddModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-custom-gradient"
              @click="addUser"
              :disabled="loadingAdd || !newUser.name || !newUser.email || !newUser.password || !newUser.password_confirmation"
            >
              <i class="fas fa-save me-1"></i>
              Cadastrar Usuário
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Editar Usuário -->
    <div v-if="showEditUserModal" class="modal-backdrop fade show" @click="closeEditModal" style="z-index: 9999;"></div>
    <div v-if="showEditUserModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="editUserModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editUserModalLabel">
              <i class="fas fa-edit me-2"></i>
              Editar Usuário
            </h5>
            <button type="button" class="btn-close" @click="closeEditModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingEdit" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Atualizando usuário...</p>
            </div>
            <div v-else>
              <div v-if="editError" class="alert alert-danger">
                {{ editError }}
              </div>
              <form @submit.prevent="updateUser">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="editUserName" class="form-label">Nome *</label>
                    <input
                      type="text"
                      class="form-control"
                      id="editUserName"
                      v-model="editUserData.name"
                      placeholder="Ex: Rafael"
                      required
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="editUserEmail" class="form-label">E-mail *</label>
                    <input
                      type="email"
                      class="form-control"
                      id="editUserEmail"
                      v-model="editUserData.email"
                      placeholder="Ex: rafael@exemplo.com"
                      required
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="editUserPassword" class="form-label">Nova Senha</label>
                    <input
                      type="password"
                      class="form-control"
                      id="editUserPassword"
                      v-model="editUserData.password"
                      placeholder="Deixe em branco para manter a senha atual"
                    >
                  </div>
                  <div class="col-12 mb-3" v-if="editUserData.password">
                    <label for="editUserPasswordConfirmation" class="form-label">Confirmar Nova Senha *</label>
                    <input
                      type="password"
                      class="form-control"
                      id="editUserPasswordConfirmation"
                      v-model="editUserData.password_confirmation"
                      placeholder="Confirme a nova senha"
                      required
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-custom-gradient"
              @click="updateUser"
              :disabled="loadingEdit || !editUserData.name || !editUserData.email || (editUserData.password && !editUserData.password_confirmation)"
            >
              <i class="fas fa-save me-1"></i>
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Detalhes do Usuário -->
    <div v-if="showDetailsModal" class="modal-backdrop fade show" @click="closeDetailsModal" style="z-index: 9999;"></div>
    <div v-if="showDetailsModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered user-details-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="userDetailsModalLabel">
              <i class="fas fa-info-circle me-2"></i>
              Detalhes do Usuário
            </h5>
            <button type="button" class="btn-close" @click="closeDetailsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-4">
            <div v-if="loadingDetails" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando detalhes do usuário...</p>
            </div>
            <div v-else-if="selectedUser" class="row">
              <div class="col-md-6">
                <div class="user-icon-container text-center mb-3">
                  <div class="user-icon-placeholder">
                    <i class="fas fa-user fa-5x text-info"></i>
                    <p class="text-muted mt-2">Usuário</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="user-details ps-3">
                  <h6 class="text-primary mb-4">{{ selectedUser.name || 'Sem nome' }}</h6>

                  <div class="detail-item mb-4">
                    <strong>ID:</strong> {{ selectedUser.id }}
                  </div>

                  <div class="detail-item mb-4">
                    <strong>E-mail:</strong>
                    <p class="text-muted mt-2 mb-0">
                      {{ selectedUser.email }}
                    </p>
                  </div>

                  <div class="detail-item mb-4" v-if="selectedUser.created_at">
                    <strong>Criado em:</strong>
                    <p class="text-muted mt-2 mb-0">
                      {{ formatDate(selectedUser.created_at) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-4">
              <div class="alert alert-danger">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Erro ao carregar detalhes do usuário
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_ENDPOINTS, apiRequest, handleApiResponse } from "@/config/api.js";
import { showSuccessAlert, showErrorAlert, showConfirmAlert } from "@/utils/swal.js";

export default {
  name: "usuarios-table",
  data() {
    return {
      usuarios: [],
      loading: false,
      error: null,
      showAddUserModal: false,
      showEditUserModal: false,
      loadingAdd: false,
      loadingEdit: false,
      addError: null,
      editError: null,
      showDetailsModal: false,
      selectedUser: null,
      editingUser: null,
      loadingDetails: false,
      newUser: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      editUserData: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    };
  },
  mounted() {
    this.loadUsuarios();
  },
  methods: {
    async loadUsuarios() {
      this.loading = true;
      this.error = null;

      try {
        const response = await apiRequest(API_ENDPOINTS.USER, {
          method: 'GET'
        });

        const data = await handleApiResponse(response);
        this.usuarios = Array.isArray(data) ? data : (data.data || data.users || data.usuarios || []);

        console.log('Usuários carregados:', this.usuarios);

      } catch (error) {
        console.error('Erro ao carregar usuários:', error);
        this.error = error.message || 'Erro ao carregar usuários';
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },

    async viewDetails(usuario) {
      this.showDetailsModal = true;
      this.selectedUser = usuario;
      this.loadingDetails = true;

      try {
        const response = await apiRequest(`${API_ENDPOINTS.USER}/${usuario.id}`, {
          method: 'GET'
        });

        const data = await handleApiResponse(response);
        this.selectedUser = data.data || data.user || data;

        console.log('Detalhes do usuário carregados:', data);

      } catch (error) {
        console.error('Erro ao carregar detalhes do usuário:', error);
        // Se falhar, usa os dados da lista como fallback
        this.selectedUser = usuario;
      } finally {
        this.loadingDetails = false;
      }
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedUser = null;
      this.loadingDetails = false;
    },

    showAddModal() {
      this.showAddUserModal = true;
      this.addError = null;
      this.newUser = {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
    },

    closeAddModal() {
      this.showAddUserModal = false;
      this.addError = null;
      this.newUser = {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
    },

    async addUser() {
      if (!this.newUser.name || !this.newUser.email || !this.newUser.password || !this.newUser.password_confirmation) {
        this.addError = 'Todos os campos são obrigatórios';
        return;
      }

      if (this.newUser.password !== this.newUser.password_confirmation) {
        this.addError = 'As senhas não coincidem';
        return;
      }

      this.loadingAdd = true;
      this.addError = null;

      try {
        const userPayload = {
          name: this.newUser.name,
          email: this.newUser.email,
          password: this.newUser.password,
          password_confirmation: this.newUser.password_confirmation
        };

        const response = await apiRequest(API_ENDPOINTS.USER, {
          method: 'POST',
          body: JSON.stringify(userPayload)
        });

        await handleApiResponse(response);

        // Sucesso! Fecha o modal e recarrega a lista
        this.closeAddModal();
        this.loadUsuarios();

        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Usuário cadastrado com sucesso!',
          'O usuário foi adicionado ao sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao cadastrar usuário:', error);
        this.addError = error.message || 'Erro ao cadastrar usuário';
      } finally {
        this.loadingAdd = false;
      }
    },

    editUser(usuario) {
      this.editingUser = usuario;
      this.editUserData = {
        name: usuario.name || '',
        email: usuario.email || '',
        password: '',
        password_confirmation: ''
      };
      this.editError = null;
      this.showEditUserModal = true;
    },

    closeEditModal() {
      this.showEditUserModal = false;
      this.editingUser = null;
      this.editError = null;
      this.editUserData = {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
    },

    async updateUser() {
      if (!this.editUserData.name || !this.editUserData.email) {
        this.editError = 'Nome e e-mail são obrigatórios';
        return;
      }

      if (this.editUserData.password && this.editUserData.password !== this.editUserData.password_confirmation) {
        this.editError = 'As senhas não coincidem';
        return;
      }

      this.loadingEdit = true;
      this.editError = null;

      try {
        const userPayload = {
          name: this.editUserData.name,
          email: this.editUserData.email
        };

        if (this.editUserData.password) {
          userPayload.password = this.editUserData.password;
          userPayload.password_confirmation = this.editUserData.password_confirmation;
        }

        const response = await apiRequest(`${API_ENDPOINTS.USER}/${this.editingUser.id}`, {
          method: 'PUT',
          body: JSON.stringify(userPayload)
        });

        await handleApiResponse(response);

        // Sucesso! Fecha o modal e recarrega a lista
        this.closeEditModal();
        this.loadUsuarios();

        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Usuário atualizado com sucesso!',
          'O usuário foi atualizado no sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao atualizar usuário:', error);
        this.editError = error.message || 'Erro ao atualizar usuário';
      } finally {
        this.loadingEdit = false;
      }
    },

    async deleteUser(usuario) {
      // Mostra confirmação antes de excluir
      const result = await showConfirmAlert(
        'Excluir Usuário',
        `Tem certeza que deseja excluir o usuário "${usuario.name}"? Esta ação não pode ser desfeita.`,
        'Sim, excluir',
        'Cancelar'
      );

      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await apiRequest(`${API_ENDPOINTS.USER}/${usuario.id}`, {
          method: 'DELETE'
        });

        await handleApiResponse(response);

        // Sucesso! Recarrega a lista
        this.loadUsuarios();

        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Usuário excluído com sucesso!',
          'O usuário foi removido do sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
        await showErrorAlert(
          'Erro ao excluir usuário',
          error.message || 'Não foi possível excluir o usuário.'
        );
      }
    }
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modal-dialog {
  width: 100%;
  margin: 0.5rem auto;
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: calc(100% - 1rem);
    margin: 0.5rem;
  }
}

.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.spinner-teal {
  color: #20c997 !important;
}

.gap-2 {
  gap: 0.5rem;
}

.text-info:hover,
.text-danger:hover {
  opacity: 0.8;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.text-info,
.text-danger {
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.user-icon-placeholder {
  padding: 40px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.user-details {
  padding: 0 10px;
}

.detail-item {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}

.detail-item:last-child {
  border-bottom: none;
}

.modal-dialog.modal-lg {
  max-height: 80vh;
}

.modal-dialog.modal-lg .modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.modal-dialog.modal-lg .modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.user-details-modal {
  max-width: 75% !important;
  width: 75% !important;
}

@media (min-width: 1200px) {
  .user-details-modal {
    max-width: 900px !important;
    width: 900px !important;
  }
}
</style>
